// @ts-nocheck
import React, {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import { Container, Alert } from "react-bootstrap";
import PageLoading from "components/PageLoading";
import { useForm } from "../../../../../../context/FormContext";
import SaveSubmitButtons from "../../../../../../components/SaveSubmitButtons/SaveSubmitButtons";
import NotificationToast from "../../../../../../components/NotificationToast/NotificationToast";
import Topic from "./Topic";
import { salvarRespostaComArquivos } from "../../../../../../services/respostaService";
import { getDocumentosByRespostaId } from "../../../../../../services";
import "./DocObrigatoriosTab.css";
import { getHistoricoAnalise } from "../../../../../../services/analiseService";
import {
  enviarAdequacao,
  salvarAdequacao,
} from "../../../../../../services/adequacaoService";

export interface DocObrigatoriosTabProps {
  isActive?: boolean;
  setActiveTab?: React.Dispatch<React.SetStateAction<string>>;
  resposta?: unknown;
  documentos?: unknown[];
  onProximo?: () => void;
  openByTopic?: Record<string, boolean>;
  onToggleOne?: (idCampoJson: string) => void;
  onTopicsLoaded?: (topics: { idCampoJson: string }[]) => void;
  showToggleAll?: boolean;
  isAllOpen?: boolean;
  onToggleAll?: () => void;
}

export interface DocObrigatoriosTabRefHandle {
  handleSave?: () => Promise<{ show?: boolean; message?: string; type?: string }>;
}

const DocObrigatoriosTab = forwardRef<DocObrigatoriosTabRefHandle, DocObrigatoriosTabProps>(
  (
    {
      isActive,
      setActiveTab,
      resposta,
      documentos,
      onProximo,
      openByTopic = {},
      onToggleOne,
      onTopicsLoaded,
      showToggleAll = false,
      isAllOpen = false,
      onToggleAll,
    },
    ref,
  ) => {
    const { updateFormData, formData } = useForm();
    const [receitaOperacional, setReceitaOperacional] = useState(0);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [errors, setErrors] = useState({});
    const [selectedOptions, setSelectedOptions] = useState({});
    const [uploadedFiles, setUploadedFiles] = useState({});
    const [topics, setTopics] = useState([]);
    const [descricaoGeral, setDescricaoGeral] = useState("");
    const [loading, setLoading] = useState(false);
    const [quantidadeAssociados, setQuantidadeAssociados] = useState(0);
    const [idResposta, setIdResposta] = useState(null);
    const [fullJson, setFullJson] = useState(null);
    const [toastData, setToastData] = useState({
      show: false,
      message: "",
      type: "",
    });
    const [podeEditar, setPodeEditar] = useState(false);
    const [dataFim, setDataFim] = useState(false);
    const initializedRef = useRef(false);
    const respostaId =
      resposta && typeof resposta === "object" && "data" in resposta
        ? (resposta as { data?: { id?: string | number } }).data?.id
        : undefined;

    useEffect(() => {
      initializedRef.current = false;
    }, [respostaId]);

    const [formDisabled, setFormDisabled] = useState(false);
    const [historicoAnalise, setHistoricoAnalise] = useState<Record<string, unknown>>({});
    const [showAdequacaoButton, setShowAdequacaoButton] = useState(false);
    const [, setDadosCadastros] = useState();
    const [modoAdequacao, setModoAdequacao] = useState(false);

    useEffect(() => {
      fetchData();
    }, [isActive, resposta, documentos]);

    const fetchData = async () => {
      if (!isActive || !resposta || initializedRef.current) return;
      initializedRef.current = true;

      try {
        const _normalizar = (str) =>
          str
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/[^\w\s-]/g, "")
            .replace(/^\d+\s*[-.]*\s*/, "")
            .trim()
            .replace(/\s+/g, "-");
        const rawJson = resposta.data?.json;
        const parsedJson =
          typeof rawJson === "string" ? JSON.parse(rawJson) : rawJson;
        const id = resposta.data?.id;

        setDadosCadastros(resposta.data);

        const temas = parsedJson?.docsObrigatorios?.[0]?.tema || [];
        const descricao = parsedJson?.docsObrigatorios?.[0]?.descricao || "";

        const resolveReferenceLink = (titulo) => {
          const t = (titulo || "")
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
          if (
            t.includes("dre") &&
            t.includes("demonstracao") &&
            t.includes("resultado")
          ) {
            return "https://docs.google.com/spreadsheets/d/1cxh6o4-Xl0wiFii091PZIrVVQ6lzkLkp/edit?gid=1907858408#gid=1907858408";
          }
          if (t.includes("ata") && t.includes("prestacao") && t.includes("contas")) {
            return "https://docs.google.com/document/d/185o2080G6Fn2ZC_0qANup2dDVU03eKaM/edit";
          }
          if (
            t.includes("relacao") &&
            t.includes("empresas") &&
            t.includes("associadas")
          ) {
            return "https://docs.google.com/spreadsheets/d/1OPh8pgL-IOcDxGfYgpehI9aluqSvxgZR/edit?gid=859316813#gid=859316813";
          }
          return null;
        };

        const parsedTopics = temas.map((tema, index) => {
          const tituloNormalizado = tema.titulo;
          return {
            id: index + 1,
            idCampoJson: tituloNormalizado,
            title: tema.titulo,
            description:
              tema.criterio?.find((c) => c?.titulo)?.titulo ||
              tema.criterio?.find((c) =>
                c?.campo?.some((campo) => campo?.titulo)
              )?.campo?.[0]?.titulo ||
              tema.descricao ||
              "",
            criterios: tema.criterio || [],
            link: resolveReferenceLink(tema.titulo) || tema.link || null,
          };
        });

        const filteredTopics = parsedTopics.filter((topic) => topic.id !== 6);

        const extrairNomeBase = (nomeArquivo) =>
          nomeArquivo
            ?.toLowerCase()
            .replace(/-?\d{4}(-\d+)?/i, "")
            .replace(/-v\d+/i, "")
            .replace(/\.(pdf|xlsx)$/i, "")
            .trim();
        const extrairVersao = (nomeArquivo) => {
          const match = nomeArquivo.match(/-v(\d+)/i);
          return match ? parseInt(match[1], 10) : 1;
        };

        const arquivosPorCampo = {};
        documentos?.forEach((doc) => {
          const nomeBase = extrairNomeBase(doc.nomeArquivo);
          const versao = extrairVersao(doc.nomeArquivo);
          if (!nomeBase) return;
          if (!arquivosPorCampo[nomeBase]) arquivosPorCampo[nomeBase] = [];
          arquivosPorCampo[nomeBase].push({ ...doc, versao });
        });

        const arquivosSelecionados = {};
        Object.entries(arquivosPorCampo).forEach(([campo, arquivos]) => {
          const arquivoMaisAtual = arquivos.sort(
            (a, b) => b.versao - a.versao
          )[0];
          arquivosSelecionados[campo] = [arquivoMaisAtual];
        });

        const selected = {};

        temas.forEach((tema, idx) => {
          const topicId = idx + 1;
          selected[topicId] = { campos: {} };

          tema.criterio?.forEach((criterio) => {
            criterio.campo?.forEach((campo) => {
              const campoKey =
                campo.idCampo || campo.titulo?.replace(/\*/g, "").trim();
              if (campoKey) {
                selected[topicId].campos[campoKey] = campo.resposta ?? "";
              }

              if (campo.tipoCampo === "radio") {
                campo.alternativa?.forEach((alt) => {
                  alt.campo?.forEach((subCampo) => {
                    const subCampoKey =
                      subCampo.idCampo ||
                      subCampo.titulo?.replace(/\*/g, "").trim();
                    if (subCampoKey) {
                      selected[topicId].campos[subCampoKey] =
                        subCampo.resposta ?? "";
                    }
                  });
                });
              }
            });
          });
        });

        const arquivosSalvos = formData?.docsObrigatorios?.uploadedFiles || {};
        const arquivosCompletos = {};
        const todosCampos = new Set([
          ...Object.keys(arquivosSelecionados),
          ...Object.keys(arquivosSalvos),
        ]);

        todosCampos.forEach((campo) => {
          const doBanco = arquivosSelecionados[campo] || [];
          const daSessao = arquivosSalvos[campo] || [];
          const combinados = [
            ...doBanco,
            ...daSessao.filter(
              (sessao) =>
                !doBanco.some((db) => db.identificador === sessao.identificador)
            ),
          ];
          arquivosCompletos[campo] = combinados;
        });

        const responseHistorico = await getHistoricoAnalise(id);
        const historico =
          responseHistorico.historicoAnaliseAdequacaoCampoQuestionarioJson ||
          [];
        const historicoMap = {};
        historico.forEach((item) => {
          historicoMap[item.idCampoJson] = { ...item, id: item.id };
        });
        setHistoricoAnalise(historicoMap);

        let qtdAssociados = selected?.[5]?.campos?.["quantas-empresa"];
        if (!qtdAssociados) {
          qtdAssociados = temas?.[4]?.criterio
            ?.find((c) =>
              c?.campo?.some((campo) => campo.idCampo === "quantas-empresa")
            )
            ?.campo?.find(
              (campo) => campo.idCampo === "quantas-empresa"
            )?.resposta;
        }
        if (qtdAssociados) setQuantidadeAssociados(parseInt(qtdAssociados));

        const linkEstatuto =
          "https://www.fiemg.com.br/wp-content/uploads/2024/06/Estatuto-FIEMG-registrado-aprovado-na-AGCR-10.04.2024-1.pdf";
        const descricaoComLink = descricao.replace(
          /Clique aqui/gi,
          `<a href="${linkEstatuto}" target="_blank" rel="noopener noreferrer">Clique aqui</a>`
        );

        const receitaOperacional = (() => {
          for (const tema of temas) {
            for (const criterio of tema.criterio || []) {
              for (const campo of criterio.campo || []) {
                if (campo.idCampo === "DRE-receita-operacional") {
                  return campo.resposta;
                }
              }
            }
          }
          return null;
        })();

        const normalizarTitulo = (titulo) => {
          let tituloNormalizado = titulo
            ?.toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/[^\w\s-]/g, "")
            .replace(/^\d+\s*[-.]*\s*/, "")
            .trim()
            .replace(/\s+/g, "-");

          if (tituloNormalizado === "dre---demonstracoes-do-resultado") {
            tituloNormalizado = "dre-demonstracoes-do-resultado";
          }
          if (
            tituloNormalizado ===
            "defesa-de-interesse-implementada-no-executivo-ou-legislativo"
          ) {
            tituloNormalizado =
              "defesa-de-interesse-implementada-no-executivo-e-legislativo";
          }

          return tituloNormalizado;
        };

        const VerificarSePodeEditar = async () => {
          try {
            const podeEditar = resposta.data.prazoEdicao;
            const datafim = resposta.data.dataFim;

            const rawJson = resposta.data?.json;
            const json =
              typeof rawJson === "string" ? JSON.parse(rawJson) : rawJson;

            const temas = json?.docsObrigatorios?.[0]?.tema || [];

            const temasFiltrados = temas.filter((tema) => {
              const titulo = tema.titulo?.trim().toUpperCase();
              return (
                titulo !==
                "6. RECEITA OPERACIONAL ANUAL / ARRECADAÇÃO MÍNIMA MENSAL"
              );
            });

            const slugsTemasPagina = temasFiltrados.map((t) =>
              normalizarTitulo(t.titulo)
            );

            const possuiAdequacaoNestaAba = Object.values(historicoMap).filter(
              (item) =>
                slugsTemasPagina.includes(normalizarTitulo(item.idCampoJson)) &&
                typeof item.dataSolicitacao === "string"
            );

            const temAdequacaoPendente = possuiAdequacaoNestaAba.some(
              (item) =>
                item.dataSolicitacao &&
                (!item.dataAdequacao || item.dataAdequacao === "")
            );

            setShowAdequacaoButton(temAdequacaoPendente);
            setModoAdequacao(temAdequacaoPendente);

            const deveDesabilitar = !(podeEditar || datafim === null);
            setFormDisabled(deveDesabilitar);
            setDataFim(datafim);
            setPodeEditar(podeEditar);
          } catch (error) {
            console.error("Erro ao verificar se pode editar:", error);
          }
        };

        await VerificarSePodeEditar();

        setDescricaoGeral(descricaoComLink);
        setTopics(filteredTopics);
        if (typeof onTopicsLoaded === "function") {
          onTopicsLoaded(filteredTopics);
        }
        setSelectedOptions(selected);
        setUploadedFiles(arquivosCompletos);
        setIdResposta(id);
        setReceitaOperacional(receitaOperacional);
        setFullJson(parsedJson);
        updateFormData("docsObrigatorios", {
          selectedOptions: selected,
          uploadedFiles: arquivosCompletos,
        });
      } catch (error) {
        console.error("❌ Erro ao carregar dados:", error);
      }
    };

    const handleCampoChange = (campoKey, valor, topicId) => {
      setSelectedOptions((prev) => {
        const campos = { ...(prev?.[topicId]?.campos || {}) };
        const atualizado = {
          ...prev,
          [topicId]: {
            ...prev?.[topicId],
            campos: {
              ...campos,
              [campoKey]: valor,
            },
          },
        };
        updateFormData("docsObrigatorios", {
          selectedOptions: atualizado,
          uploadedFiles,
        });
        return atualizado;
      });
    };

    const handleFileUpload = (campoNomeArquivo, files) => {
      const atualizados = {
        ...uploadedFiles,
        [campoNomeArquivo]: files,
      };
      setUploadedFiles(atualizados);
      updateFormData("docsObrigatorios", {
        selectedOptions,
        uploadedFiles: atualizados,
      });
    };

    const _isFormValid = () => {
      const newErrors = {};
      topics.forEach((topic) => {
        if (!selectedOptions[topic.id]) {
          newErrors[topic.id] = true;
        }
      });
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    };

    const filtrarUltimaVersao = (documentos) => {
      const arquivosPorCampo = {};

      documentos.forEach((doc) => {
        const nomeBase = doc.nomeArquivo
          ?.toLowerCase()
          .replace(/-?\d{4}(-\d+)?/i, "")
          .replace(/-v\d+/i, "")
          .replace(/\.(pdf|xlsx)$/i, "")
          .trim();

        if (!nomeBase) return;

        const versaoMatch = doc.nomeArquivo.match(/-v(\d+)/i);
        const versao = versaoMatch ? parseInt(versaoMatch[1], 10) : 1;

        if (!arquivosPorCampo[nomeBase]) arquivosPorCampo[nomeBase] = [];

        arquivosPorCampo[nomeBase].push({ ...doc, versao });
      });

      const arquivosUltimaVersao = {};

      Object.keys(arquivosPorCampo).forEach((campo) => {
        const arquivos = arquivosPorCampo[campo];
        const arquivoMaisAtual = arquivos.sort(
          (a, b) => b.versao - a.versao
        )[0];
        arquivosUltimaVersao[campo] = [arquivoMaisAtual];
      });

      return arquivosUltimaVersao;
    };

    const normalizeIdCampoJson = (str) =>
      str
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^\w-]/g, "");

    const handleAnalysisChange = (idCampoJson, valoresAtualizados) => {
      const key = normalizeIdCampoJson(idCampoJson);
      setHistoricoAnalise((prev) => ({
        ...prev,
        [key]: {
          ...prev[key],
          ...valoresAtualizados,
          id: prev[key]?.id || 0,
          idCampoJson: key,
        },
      }));
    };

    const handleEnviarAdequacao = async () => {
      const rawJson = resposta.data?.json;
      const json = typeof rawJson === "string" ? JSON.parse(rawJson) : rawJson;

      const temas = [
        ...(json?.docsObrigatorios?.[0]?.tema || []),
        ...(json?.docsBonus?.[0]?.tema || []),
        ...(json?.docsBonusExtra?.[0]?.tema || []),
      ];

      const temasFiltrados = temas.filter((tema) => {
        const titulo = tema.titulo?.trim().toUpperCase();
        return ![
          "6. RECEITA OPERACIONAL ANUAL / ARRECADAÇÃO MÍNIMA MENSAL",
          "7. EVOLUÇÃO RECEITA OPERACIONAL",
          "8. 80% DE RETENÇÃO DE ASSOCIADOS",
          "9. EVOLUÇÃO DO ASSOCIATIVISMO",
        ].includes(titulo);
      });

      const normalizarTitulo = (titulo) => {
        let tituloNormalizado = titulo
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/[^\w\s-]/g, "")
          .replace(/^\d+\s*[-.]*\s*/, "")
          .trim()
          .replace(/\s+/g, "-");

        if (tituloNormalizado === "dre---demonstracoes-do-resultado") {
          tituloNormalizado = "dre-demonstracoes-do-resultado";
        }

        if (
          tituloNormalizado ===
          "defesa-de-interesse-implementada-no-executivo-ou-legislativo"
        ) {
          tituloNormalizado =
            "defesa-de-interesse-implementada-no-executivo-e-legislativo";
        }

        return tituloNormalizado;
      };

      const slugsTemasPagina = temasFiltrados.map((t) =>
        normalizarTitulo(t.titulo)
      );

      const adequacoesRelevantes = Object.entries(historicoAnalise)
        .filter(([key, item]) => {
          const slugKey = normalizarTitulo(key);
          return (
            slugsTemasPagina.includes(slugKey) &&
            typeof item.dataSolicitacao === "string"
          );
        })
        .map(([_, item]) => item);

      const camposPendentes = adequacoesRelevantes.filter(
        (item) => item.adequacaoRealizada !== true
      );

      const todasAdequacoesMarcadas = adequacoesRelevantes.every(
        (item) => item.adequacaoRealizada === true
      );

      if (!todasAdequacoesMarcadas) {
        const camposFaltando = camposPendentes.map((item) => ({
          tema: item.tema,
          titulo: item.titulo || item.idCampoJson,
        }));

        setToastData({
          show: true,
          message: (
            <>
              <p>Você precisa marcar as adequações dos seguintes campos:</p>
              <ul style={{ marginTop: 6, marginBottom: 4, paddingLeft: 20 }}>
                {camposFaltando.map((campo, idx) => (
                  <li key={campo.titulo + idx} style={{ marginBottom: 4 }}>
                    <strong>{campo.tema ? campo.tema + ": " : ""}</strong>
                    <span style={{ textTransform: "capitalize" }}>
                      {campo.titulo.replace(/-/g, " ")}
                    </span>
                  </li>
                ))}
              </ul>
            </>
          ),
          type: "error",
        });
        return;
      }

      const adequacoesValidas = Object.values(historicoAnalise).filter(
        (item) =>
          (item.obsAnalista ||
            item.obsSindicato ||
            item.adequacaoRealizada !== undefined) &&
          item.id > 0
      );

      try {
        setLoading(true);

        const jsonAtualizado = {
          ...fullJson,
          receitaOperacional:
            receitaOperacional?.toString().trim() !== ""
              ? receitaOperacional
              : null,
          docsObrigatorios: [
            {
              ...fullJson?.docsObrigatorios?.[0],
              tema: fullJson?.docsObrigatorios?.[0]?.tema.map((tema, idx) => {
                const topicId = idx + 1;
                const respostasTopico = selectedOptions[topicId] || {};
                const camposPreenchidos = respostasTopico.campos || {};

                const atualizarCampos = (campos) =>
                  campos?.map((campo) => {
                    const campoKey =
                      campo.idCampo || campo.titulo?.replace(/\*/g, "").trim();
                    let respostaBruta =
                      camposPreenchidos[campoKey] ?? campo.resposta ?? "";
                    const respostaNormalizada =
                      respostaBruta?.toString().trim() === ""
                        ? null
                        : respostaBruta;

                    if (campo.tipoCampo === "radio") {
                      return {
                        ...campo,
                        resposta: respostaNormalizada,
                        alternativa: campo.alternativa?.map((alt) => {
                          if (alt.campo) {
                            return {
                              ...alt,
                              campo: atualizarCampos(alt.campo),
                            };
                          }
                          return alt;
                        }),
                      };
                    }

                    return {
                      ...campo,
                      resposta: respostaNormalizada,
                    };
                  });

                return {
                  ...tema,
                  criterio: tema.criterio?.map((criterio) => ({
                    ...criterio,
                    campo: atualizarCampos(criterio.campo),
                  })),
                };
              }),
            },
          ],
        };

        const receitaAtualizada = (() => {
          try {
            const temas = jsonAtualizado?.docsObrigatorios?.[0]?.tema || [];
            for (const tema of temas) {
              for (const criterio of tema.criterio || []) {
                for (const campo of criterio.campo || []) {
                  if (campo.idCampo === "DRE-receita-operacional") {
                    return campo.resposta;
                  }
                }
              }
            }
            return null;
          } catch (err) {
            console.error("❌ Erro ao extrair receitaAtualizada:", err);
            return null;
          }
        })();

        const arquivosParaEnvio = Object.values(uploadedFiles)
          .flat()
          .filter((file) => file instanceof File);

        const responsavelPreenchimento =
          localStorage.getItem("responsavelQuestionaro") || "";
        const cargoResponsavel = localStorage.getItem("cargoResponsavel") || "";

        await salvarRespostaComArquivos(
          idResposta,
          jsonAtualizado,
          receitaAtualizada,
          arquivosParaEnvio,
          {
            responsavelPreenchimento,
            cargoResponsavel,
          }
        );

        const payload = {
          Json: jsonAtualizado,
          ResponsavelPreenchimento: responsavelPreenchimento,
          CargoResponsavel: cargoResponsavel,
          ReceitaOperacional: receitaAtualizada,
          PercentualConclusao: 0,
          AdequacaoCamposQuestionarioJson: JSON.stringify(
            adequacoesValidas.map((item) => ({
              Id: item.id,
              ObsSindicato: item.obsSindicato || "",
              AdequacaoRealizada: item.adequacaoRealizada === true,
              IdCampoJson: item.idCampoJson,
              IdQuestionarioResposta: idResposta,
            }))
          ),
        };

        await enviarAdequacao(idResposta, payload);

        const documentosAtualizados = await getDocumentosByRespostaId(
          idResposta
        );
        const arquivosAtualizados = filtrarUltimaVersao(documentosAtualizados);
        setUploadedFiles(arquivosAtualizados);

        setToastData({
          show: true,
          message: "Adequação enviada com sucesso!",
          type: "success",
        });

        setTimeout(() => window.location.reload(), 500);
      } catch (error) {
        console.error("❌ Erro ao enviar adequação:", error);
        setToastData({
          show: true,
          message: "Erro ao enviar adequação!",
          type: "error",
        });
      } finally {
        setLoading(false);
      }
    };

    const handleSave = async () => {
      try {
        setLoading(true);

        const jsonAtualizado = {
          ...fullJson,
          receitaOperacional:
            receitaOperacional?.toString().trim() !== ""
              ? receitaOperacional
              : null,
          docsObrigatorios: [
            {
              ...fullJson?.docsObrigatorios?.[0],
              tema: fullJson?.docsObrigatorios?.[0]?.tema.map((tema, idx) => {
                const topicId = idx + 1;
                const respostasTopico = selectedOptions[topicId] || {};
                const camposPreenchidos = respostasTopico.campos || {};

                const atualizarCampos = (campos) =>
                  campos?.map((campo) => {
                    const campoKey =
                      campo.idCampo || campo.titulo?.replace(/\*/g, "").trim();

                    let respostaBruta =
                      camposPreenchidos[campoKey] ?? campo.resposta ?? "";

                    const respostaNormalizada =
                      respostaBruta?.toString().trim() === ""
                        ? null
                        : respostaBruta;

                    if (campo.tipoCampo === "radio") {
                      return {
                        ...campo,
                        resposta: respostaNormalizada,
                        alternativa: campo.alternativa?.map((alt) => {
                          if (alt.campo) {
                            return {
                              ...alt,
                              campo: atualizarCampos(alt.campo),
                            };
                          }
                          return alt;
                        }),
                      };
                    }

                    return {
                      ...campo,
                      resposta: respostaNormalizada,
                    };
                  });

                return {
                  ...tema,
                  criterio: tema.criterio?.map((criterio) => ({
                    ...criterio,
                    campo: atualizarCampos(criterio.campo),
                  })),
                };
              }),
            },
          ],
        };

        const receitaAtualizada = (() => {
          try {
            const temas = jsonAtualizado?.docsObrigatorios?.[0]?.tema || [];
            for (const tema of temas) {
              for (const criterio of tema.criterio || []) {
                for (const campo of criterio.campo || []) {
                  if (campo.idCampo === "DRE-receita-operacional") {
                    return campo.resposta;
                  }
                }
              }
            }
            return null;
          } catch (err) {
            console.error("❌ Erro ao extrair receitaAtualizada:", err);
            return null;
          }
        })();

        const arquivosParaEnvio = Object.values(uploadedFiles)
          .flat()
          .filter((file) => file instanceof File);

        const responsavelPreenchimento =
          localStorage.getItem("responsavelQuestionaro") || "";
        const cargoResponsavel = localStorage.getItem("cargoResponsavel") || "";

        await salvarRespostaComArquivos(
          idResposta,
          jsonAtualizado,
          receitaAtualizada,
          arquivosParaEnvio,
          {
            responsavelPreenchimento,
            cargoResponsavel,
          }
        );

        const emModoAdequacao = !!showAdequacaoButton;

        const adequacoesValidas = Object.values(historicoAnalise).filter(
          (item) =>
            (item.obsAnalista ||
              item.obsSindicato ||
              item.adequacaoRealizada !== undefined) &&
            item.id > 0
        );

        if (emModoAdequacao && adequacoesValidas.length > 0) {
          const payloadAdequacao = {
            Json:
              typeof jsonAtualizado === "string"
                ? jsonAtualizado
                : JSON.stringify(jsonAtualado),
            ResponsavelPreenchimento: responsavelPreenchimento,
            CargoResponsavel: cargoResponsavel,
            ReceitaOperacional: parseFloat(receitaAtualizada) || 0,
            PercentualConclusao: 0,
            AdequacaoCamposQuestionarioJson: JSON.stringify(
              adequacoesValidas.map((item) => ({
                Id: item.id,
                ObsSindicato: item.obsSindicato || "",
                AdequacaoRealizada: item.adequacaoRealizada === true,
                IdCampoJson: item.idCampoJson,
                IdQuestionarioResposta: idResposta,
              }))
            ),
            Arquivos: [],
          };

          await salvarAdequacao(idResposta, payloadAdequacao);
        }

        const documentosAtualizados = await getDocumentosByRespostaId(
          idResposta
        );
        const arquivosAtualizados = filtrarUltimaVersao(documentosAtualizados);

        setUploadedFiles(arquivosAtualizados);
        updateFormData("docsObrigatorios", {
          selectedOptions,
          uploadedFiles: arquivosAtualizados,
        });

        setToastData({
          show: true,
          message: "Documentos obrigatórios salvos com sucesso!",
          type: "success",
        });

        return {
          show: true,
          message: "Documentos obrigatórios salvos com sucesso!",
          type: "success",
        };
      } catch (error) {
        console.error("❌ Erro ao salvar documentos obrigatórios:", error);
        if (error.response) {
          console.error("📩 Resposta do backend:", error.response.data);

          const erros = error.response.data?.errors;
          if (erros) {
            Object.entries(erros).forEach(([campo, mensagens]) => {
              console.error(` - ${campo}: ${mensagens.join(", ")}`);
            });
          }
        }

        setToastData({
          show: true,
          message: "Erro ao salvar documentos obrigatórios.",
          type: "error",
        });

        return {
          show: true,
          message: "Erro ao salvar documentos obrigatórios.",
          type: "error",
        };
      } finally {
        setLoading(false);
      }
    };

    useImperativeHandle(ref, () => ({
      handleSave,
    }));

    const handleSubmit = async () => {
      const result = await handleSave();
      if (result?.type === "success") {
        onProximo();
      }
    };

    const _handleCancel = () => setShowConfirmation(false);

    return (
      <Container className="doc-obrigatorios-container">
        {loading ? (
          <PageLoading minHeight="60vh" />
        ) : !showConfirmation ? (
          <>
            {!podeEditar && dataFim !== null && !showAdequacaoButton && (
              <Alert variant="warning" className="mt-3">
                Você não pode mais editar os dados de Documentos Obrigatórios.
              </Alert>
            )}

            <div className="shipping-tab-header">
              <h1 className="cadastro-title">DOCUMENTOS OBRIGATÓRIOS</h1>

              {showToggleAll && (
                <button
                  type="button"
                  className="shipping-toggle-all"
                  onClick={onToggleAll}
                  aria-label={isAllOpen ? "Recolher tudo" : "Expandir tudo"}
                  title={
                    isAllOpen
                      ? "Recolher todos os tópicos"
                      : "Expandir todos os tópicos"
                  }
                >
                  {isAllOpen ? "Recolher tudo" : "Expandir tudo"}
                </button>
              )}
            </div>

            {descricaoGeral && (
              <div
                className="doc-obrigatorios-info"
                dangerouslySetInnerHTML={{
                  __html: `<em>${descricaoGeral}</em>`,
                }}
              />
            )}

            {topics.length === 0 ? (
              <PageLoading minHeight="60vh" />
            ) : (
              <>
                {topics.map((topic) => (
                  <Topic
                    key={topic.id}
                    data={topic}
                    onFileUpload={handleFileUpload}
                    hasError={!!errors[topic.id]}
                    idResposta={idResposta}
                    uploadedFiles={uploadedFiles}
                    selectedOptions={selectedOptions}
                    setSelectedOptions={setSelectedOptions}
                    handleCampoChange={handleCampoChange}
                    quantidadeAssociados={quantidadeAssociados}
                    setQuantidadeAssociados={setQuantidadeAssociados}
                    disabled={formDisabled}
                    historico={historicoAnalise}
                    onAnalysisChange={handleAnalysisChange}
                    modoAdequacao={modoAdequacao}
                    isOpen={openByTopic[topic.idCampoJson] === true}
                    onToggle={onToggleOne ? () => onToggleOne(topic.idCampoJson) : undefined}
                  />
                ))}
                <div className="buttons-container">
                  <SaveSubmitButtons
                    onSave={handleSave}
                    onSubmit={handleSubmit}
                    onAdequacaoSubmit={handleEnviarAdequacao}
                    podeEditar={podeEditar}
                    temAdequacao={showAdequacaoButton}
                  />
                </div>
                <NotificationToast
                  show={toastData.show}
                  onClose={() => setToastData((prev) => ({ ...prev, show: false }))}
                  message={toastData.message}
                  type={toastData.type}
                />
              </>
            )}
          </>
        ) : null}
      </Container>
    );
  }
);

export default DocObrigatoriosTab;